import React, { Suspense, lazy } from "react"
import ReactDOM from "react-dom"
import { Layout } from "./Layout/Layout"
import * as serviceWorker from "./serviceWorker"
import Spinner from "./ToolKit/spinner/Fallback-spinner"
import "./Static/css/custom.scss"
import "./Static/css/helper.scss"

const LazyApp = lazy(() => import("./App"))

// configureDatabase()

ReactDOM.render(
      <Suspense fallback={<Spinner />}>
        <Layout>
            <LazyApp />
        </Layout>
      </Suspense>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
